import { Button } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import React from "react";
import NetsEasySubscription from "./NetsEasySubscription";

const useStyles = createStyles(() => ({
  goBack: {
    textAlign: "center",
    paddingTop: "50px",
  },
}));

const UpdateSubscription = ({ data, language, updateSubscription }) => {
  const { classes } = useStyles();

  return (
    <>
      <div className={classes.goBack}>
        <span className={classes.goBack}>
          <Button
            variant="primary"
            className={`primaryButton onepage_payment__cancel`}
            onClick={() => window.history.back()}
          >
            {language.Go_Back}
          </Button>
        </span>
      </div>
      <NetsEasySubscription
        paymentMethods={data.paymentMethods}
        subscriptionId={data.subscriptionById.id}
        updateSubscription={updateSubscription}
      />
    </>
  );
};

export default UpdateSubscription;
